// @flow
import AthenaIcon from 'components/AthenaIcon'
import ChirotouchIcon from 'components/ChirotouchIcon'
import ElationIcon from 'components/ElationIcon'
import OpenDentalIcon from 'components/OpenDentalIcon'
import join from 'lodash/join'
import * as React from 'react'
import { formatPhoneNumber } from 'react-phone-number-input'
import type { Customer } from 'types/Customer'
import { buildPhoneNumberValue } from 'ui/SingleLinePhone'
import { hasText } from 'utils/helpers'

type Props = {
  patient: {
    date_birth_us: string,
  } & Customer,
}

function PatientDropdownLabel({ patient }: Props): React.Node {
  const detailsArray = []

  if (hasText(patient.email)) {
    detailsArray.push(patient.email)
  }

  if (hasText(patient.phone_number)) {
    const formattedPhoneNumber = formatPhoneNumber(
      buildPhoneNumberValue(patient.phone_number)
    )
    detailsArray.push(formattedPhoneNumber)
  }

  if (hasText(patient.date_birth_us)) {
    detailsArray.push(patient.date_birth_us)
  }

  const detailsText = join(detailsArray, ', ')

  return (
    <div>
      <div>
        <span className="text-sm font-medium text-txt-emphasis">{`${patient.first_name} ${patient.last_name}`}</span>
        {patient.is_linked_to_elation ? (
          <div className="inline-block">
            <ElationIcon />
          </div>
        ) : null}

        {patient.is_linked_to_chirotouch ? (
          <div className="inline-block">
            <ChirotouchIcon />
          </div>
        ) : null}

        {patient.is_linked_to_athena ? (
          <div className="inline-block">
            <AthenaIcon />
          </div>
        ) : null}

        {patient.is_linked_to_open_dental ? (
          <div className="inline-block">
            <OpenDentalIcon />
          </div>
        ) : null}
      </div>
      <p className="text-xs leading-4 text-txt">{detailsText}</p>
    </div>
  )
}

export default PatientDropdownLabel
